// EditableField.js
import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";

const EditableField = ({ label, value, onEdit }) => {
  const [editing, setEditing] = useState(false);
  const [fieldValue, setFieldValue] = useState(value);

  const handleEdit = () => {
    setEditing(true);
  };

  const handleSubmit = () => {
    onEdit(fieldValue);
    setEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setEditing(false);
      handleSubmit();
    }
  };

  return (
    <div className="flex items-center mb-3">
      <label className="text-xl font-semibold mr-2">{label}:</label>
      {editing ? (
        <input
          className="px-3 py-1 border border-gray-300 rounded bg-gray-100 focus:outline-none focus:ring focus:border-blue-400"
          type="text"
          value={fieldValue}
          onChange={(e) => setFieldValue(e.target.value)}
          onKeyDown={handleKeyPress}
        />
      ) : (
        <p className="text-lg text-gray-700">{value}</p>
      )}
      {editing ? (
        <button
          className="ml-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-400"
          onClick={handleSubmit}
        >
          Guardar
        </button>
      ) : (
        <FaEdit
          className="ml-2 cursor-pointer text-gray-500"
          onClick={handleEdit}
        />
      )}
    </div>
  );
};

export default EditableField;
